import React, { FC } from 'react';
import { Card, Drawer, Stack, Text } from '@mantine/core';
import * as A from 'fp-ts/Array';
import { pipe } from 'fp-ts/function';
import { ordFromOrdering } from '@shared/utils/order';
import { Previsions } from '@shared/modules/previsions/model';
import Weather = Previsions.Weather;

interface WeatherParamDescriptionDrawerProps {
  opened: boolean;
  onClose(): void;
}

const WeatherParamDescriptionDrawer: FC<WeatherParamDescriptionDrawerProps> = ({ opened, onClose }) => {
  return (
    <Drawer
      opened={opened}
      onClose={onClose}
      title={
        <Text fz={22} fw={700} lh={1.4}>
          Légende données météo
        </Text>
      }
    >
      <Stack c="dark.5" spacing={10}>
        {pipe(
          Object.values(Weather.DayForecast.KnownParam),
          A.sort(ordFromOrdering(Weather.DayForecast.paramOrdering)),
          A.map(param => (
            <Card key={param} lh={1.55} radius={8} bg="tertiary.2" withBorder={false}>
              <Text fw={600} fz={14}>
                {Weather.DayForecast.paramLabel[param]}
              </Text>
              <Text fw={400} fz={12}>
                {Weather.DayForecast.paramDescription[param]}
              </Text>
            </Card>
          )),
        )}
      </Stack>
    </Drawer>
  );
};

export default WeatherParamDescriptionDrawer;
